export const isDefined = <T>(value: T | undefined): value is T =>
  value !== undefined;
export const isUndefined = (value: any): value is undefined =>
  !isDefined(value);
